/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fa[_ngcontent-%COMP%]{color:var(--menu-inactive-color);font-size:2.6rem}.fa[_ngcontent-%COMP%]:hover{color:var(--text-color)}"];
export { styles as styles };
